<script>
   window.location.href="/apply.php";
</script>
{#if false}
<div class="image-background">
	<h1 class="header_text_wrapper text-left"><span>CAREERS</span><span class="separator"></span></h1>
</div>
<div class="page-content">
	<section class="container-fluid">
		<div role="form" class="wpcf77 home_block_box_bg">
            <img src="/images/loader.gif" id="gif" style="display: none; margin: 0 auto; width: 100px; visibility: hidden;" alt="">
            <div id="wait" style="display: none; margin: 0 auto;visibility: hidden;"> Please wait...submitting details...</div>
            <br>
            <fieldset class="contact_form_cust">
               <legend>
                  <h4>Apply to be a part of our great hospitality Team!</h4>
               </legend>
               <div class="cont_form">
                  <form id="profile_form" name="profile_form" action="http://bookings.mangomist.com/apply_api.php" method="post" class="wpcf7-form" enctype="multipart/form-data">
                     <input name="submitcode" id="submitcode" type="hidden">
                     <div class="row">
                        <div class="col-sm-4">
                           <div class="form-group first_name"><label for="" class="">First Name <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control" name="first_name" id="first_name" value="" aria-invalid="false" aria-required="true" required="" type="text"></div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group middle_name"><label for="" class="">Middle Name </label><input class="wpcf7-form-control wpcf7-text  form-control" name="middle_name" value="" type="text"></div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group last_name"><label for="" class="">Last Name <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control" name="last_name" id="last_name" value="" aria-invalid="false" aria-required="true" required="" type="text"></div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group"><label for="" class="">Phone Number <span class="required">*</span></label><span class="phone_num"></span><input class="wpcf7-form-control wpcf7-number wpcf7-validates-as-required wpcf7-validates-as-number form-control" name="phone_num" id="phone_num" value="" aria-invalid="false" aria-required="true" required="" type="text" maxlength="10" onkeypress="return isNumber(event)" placeholder="Enter 10 digits mobile number"></div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group email"><label for="" class="">Email <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email form-control" id="email" name="email" value="" aria-invalid="false" aria-required="true" required="" type="text"></div>
                        </div>
                        <div class="col-sm-4">
                           <label for="" class="">DOB<span class="required">*</span></label>
                           <div class="form-group dob">
                              <input class="wpcf7-form-control form-control" name="dob" id="dob" value="" type="date">
                           </div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group address"><label for="" class="">Address <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control" name="address" id="address" value="" aria-invalid="false" aria-required="true" required="" type="text"></div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group city"><label for="" class="">City <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control" name="city" id="city" value="" aria-invalid="false" aria-required="true" required="" type="text"></div>
                        </div>
                        <div class="col-sm-4">
                           <p>&nbsp;</p>
                           <div class="form-group wpcf7-form-control wpcf7-radio gender">
                              <label for="" class="">Gender <span class="required">*</span></label>
                              <label><input name="gender" value="M" checked="checked" aria-invalid="false" type="radio">&nbsp;Male &nbsp;</label> &nbsp;
                              <label><input name="gender" value="F" aria-invalid="false" type="radio"> Female</label>
                           </div>
                        </div>
                        <div class="col-sm-6">
                           <br>
                           <div class="form-group wpcf7-form-control wpcf7-radio mstatus">
                              <label for="" class="">Marital Status <span class="required">*</span></label>
                              <label><input name="mstatus" value="1" checked="checked" aria-invalid="false" type="radio">&nbsp;Married &nbsp;</label> &nbsp;
                              <label><input name="mstatus" value="0" aria-invalid="false" type="radio"> Unmarried</label>
                           </div>
                        </div>
                        <div class="col-sm-6">
                           <br>
                           <div class="form-group wpcf7-form-control wpcf7-radio current_emp_status">
                              <label for="" class="">Currently employed <span class="required">*</span></label>
                              <label><input name="current_emp_status" value="Y" aria-invalid="false" type="radio">&nbsp;Yes &nbsp;</label> &nbsp;
                              <label><input name="current_emp_status" value="N" checked="checked" aria-invalid="false" type="radio"> No</label>
                           </div>
                        </div>
                        <div class="current_emp" style="display:none;">
                           <div class="col-sm-4">
                              <div class="form-group cemployer"><label for="" class="">Current Employer</label><input class="wpcf7-form-control wpcf7-text form-control" name="cemployer" value="" aria-invalid="false" type="text"></div>
                           </div>
                           <div class="col-sm-4">
                              <div class="form-group position"><label for="" class="">Position</label><input class="wpcf7-form-control wpcf7-text form-control" name="position" value="" aria-invalid="false" type="text"></div>
                           </div>
                           <div class="col-sm-4">
                              <div class="form-group notice_period"><label for="" class="">Notice Period</label><input class="wpcf7-form-control wpcf7-text form-control" name="notice_period" value="" aria-invalid="false" type="text"></div>
                           </div>
                           <div class="col-sm-4">
                              <div class="form-group ctc"><label for="" class="">CTC</label><input class="wpcf7-form-control wpcf7-text form-control" name="ctc" value="" aria-invalid="false" type="text"></div>
                           </div>
                           <div class="col-sm-4">
                              <div class="form-group salary"><label for="" class="">Salary(SCAN COPY)(MAX 1MB)</label><input class="wpcf7-form-control wpcf7-file " name="salary" aria-invalid="false" type="file"></div>
                           </div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group apply_position"><label for="" class="">Apply Position</label><input class="wpcf7-form-control wpcf7-text form-control" name="apply_position" value="" aria-invalid="false" type="text"></div>
                        </div>
                        <div class="col-sm-4" style="padding-bottom:20px">
                           <div class="form-group cv"><label for="" id="cvlable">Upload CV(MAX 1MB) <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-file wpcf7-validates-as-required " id="cv" name="cv" aria-invalid="false" aria-required="true" required="" type="file"></div>
                        </div>
                        <div class="col-sm-4" style="padding-bottom:20px">
                           <div class="form-group photo"><label for="" class="">Upload Photo(MAX 1MB) </label><input class="wpcf7-form-control wpcf7-file wpcf7-validates-as-required " name="photo" aria-invalid="false" aria-required="true" required="" type="file"></div>
                        </div>
                        <div class="col-sm-4">
                           <div class="form-group govtid"><label for="" class="" id="idlable">Government ID(MAX 1MB) <span class="required">*</span></label><input class="wpcf7-form-control wpcf7-file wpcf7-validates-as-required " name="govtid" id="govtid" aria-invalid="false" aria-required="true" required="" type="file"></div>
                        </div>
                     </div>
                     <div class="row" style="text-align:center;">
                        <div class="col-sm-12">
                           <div class="btn-primary-container">
                              <input class="wpcf7-form-control wpcf7-submit btn btn-primary style-1" name="submit1" value="Apply" id="career_form_submit" type="button">
                           </div>
                        </div>
                        <div class="col-sm-12">
                           <div class="btn-primary-container">
                              <p style="font-size:16px">(An OTP will be sent to the mentioned mobile number to confirm the application)</p>
                           </div>
                        </div>
                     </div>
                     <a id="inline" href="#data" style="display:none">This shows content of element who has id="data"</a>
                     <div style="display:none">
                        <div id="data">
                           <div id="loginerrormsg"></div>
                           <fieldset>
                              <legend>Verification</legend>
                              <div class="clearfix">
                                 <input type="text" name="code" value="" style="width:120px;" class="forminput" id="code">
                              </div>
                              <button class="wpcf7-form-control wpcf7-submit btn btn-primary style-1" style="padding:5px;font-size:10px;margin-top:10px;" type="button" onclick="formloginValidation();">Submit</button><br> <span style="font-size:10px;">(Enter OTP Sent to Your Mobile Number <span id="verifymobile"></span>)<span>
                              </span></span>
                           </fieldset>
                        </div>
                     </div>
                  </form>
               </div>
            </fieldset>
         </div>
	</section>
</div>
{/if}
<style>

    .image-background {
        background: url("../images/Careers.jpg") no-repeat center;
    }
    /* The Modal (background) */
    
  
    
    @-webkit-keyframes animatetop {
        from {
            top: -300px;
            opacity: 0
        }
        to {
            top: 0;
            opacity: 1
        }
    }
    
    @keyframes animatetop {
        from {
            top: -300px;
            opacity: 0
        }
        to {
            top: 0;
            opacity: 1
        }
    }

    .home_block_box_bg {
        padding-top: 45px;
        -moz-border-bottom-colors: none;
        -moz-border-left-colors: none;
        -moz-border-right-colors: none;
        -moz-border-top-colors: none;
        background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
        border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
        border-image: none;
        border-radius: 25px;
        box-shadow: 8px 8px 8px #888888;
    }

    .page-content {
        background: rgba(0, 0, 0, 0) url(../images/gpattern-opacity-1.png) repeat scroll 0 0;
        padding-top: 35px;
    }

    .contact_form_cust {
        height: 100%;
    }

    fieldset.contact_form_cust {
        padding-left: 45px;
        padding-right: 45px;
    }

    .cont_form {
        padding-top: 30px;
    }

    .form-control {
        height: 48px;
        font-size: 1rem;
        color: #444;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        border-radius: 0;
    }
</style>